<template>
    <div v-if="$store.state.readyState" class="rocket">
        <div v-if="rocketReady" class="wrapper">
            <div class="rocket__hero">
                <img v-on:load="imageLoaded()" :src="rocket.flickr_images[0]" class="img img--bg" alt="">
                <div class="rocket__hero-content">
                    <h2>{{rocket.rocket_name}}</h2>
                    <p>{{rocket.description}}</p>
                </div><!-- /.rocket__hero-content -->
            </div><!-- /.rocket__hero -->
            <div class="rocket-info-grid">
                <div class="rocket-info">
                    <h3 class="rocket-info__title">General</h3>
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Currently Active:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.active ? 'Active' : 'Not active'}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Cost Per Launch:
                        </span>
                        <span class="rocket-card__icon-value">
                            ${{rocket.cost_per_launch.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Stages:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.stages}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Number of launches: 
                        </span>
                        <span class="rocket-card__icon-value">
                            {{numOfLaunches}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Success Rate: 
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.success_rate_pct}}%
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Boosters: 
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.boosters}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                </div><!-- /.rocket-info -->
                <div class="rocket-info">
                    <h3 class="rocket-info__title">Engines</h3>
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Layout:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.engines.layout}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Number of Engines:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.engines.number}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Engine Type:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.engines.type}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Propellant 1:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.engines.propellant_1}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Propellant 2:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.engines.propellant_2}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                </div><!-- /.rocket-info -->
                <div class="rocket-info">
                    <h3 class="rocket-info__title">Specifications</h3>
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Diameter:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.diameter.feet}} ft  /  {{rocket.diameter.meters}} meters
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Height:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.height.feet}} ft  /  {{rocket.height.meters}} meters
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Mass:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.mass.kg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} KG  /  {{rocket.mass.lb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} lb
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Number of legs:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.landing_legs.number}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Landing Leg Material:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.landing_legs.material}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                </div><!-- /.rocket-info -->
                <div class="rocket-info">
                    <h3 class="rocket-info__title">Payloads</h3>
                    <div v-for="(payload, index) in rocket.payload_weights" :key="index" class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            {{payload.name}}
                        </span>
                        <span class="rocket-card__icon-value">
                            {{payload.kg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} kg  /  {{payload.lb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} lb
                        </span>
                    </div><!-- /.rocket-card__icon -->
                </div><!-- /.rocket-info -->
                <div class="rocket-info">
                    <h3 class="rocket-info__title">First Stage</h3>
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Burn Time (seconds): 
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.first_stage.burn_time_sec}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Fuel Amount (Tons):
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.first_stage.fuel_amount_tons}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Stage is reusable:
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.first_stage.reusable ? 'Reusable' : 'Not Reusable'}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Thrust at sea-level (pounds of force): 
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.first_stage.thrust_sea_level.lbf.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Thrust in vacuum (pounds of force): 
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.first_stage.thrust_vacuum.lbf.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                </div><!-- /.rocket-info -->
                <div class="rocket-info">
                    <h3 class="rocket-info__title">Second Stage</h3>
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Burn Time (seconds): 
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.second_stage.burn_time_sec}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Fuel Amount (Tons):
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.second_stage.fuel_amount_tons}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Payloads Option 1: 
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.second_stage.payloads.option_1}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                    <div class="rocket-card__icon rocket-info__icon">
                        <span class="rocket-card__icon-label">
                            Thrust (pounds of force): 
                        </span>
                        <span class="rocket-card__icon-value">
                            {{rocket.second_stage.thrust.lbf.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                        </span>
                    </div><!-- /.rocket-card__icon -->
                </div><!-- /.rocket-info -->
            </div><!-- /.rocket-info-grid -->
            <div class="image-grid">
                <div v-for="(image, index) in rocket.flickr_images" :key="index" class="image-grid__image">
                    <img :src="image" class="img img--bg" alt="">
                </div><!-- /.image-grid__image -->    
            </div><!-- /.image-grid -->
        </div><!-- /.wrapper -->
    </div><!-- /.mission -->
</template>

<script>
import objectFitImages from 'object-fit-images'
import jQuery from 'jquery'

export default {
    name: 'Rocket',
    components: {
        
    },
    data() {
        return {
            id: null,
            rocket: null,
            apiUrl: `https://api.spacexdata.com/v3/rockets`,
            rocketReady: false,
            numOfLaunches: null,
        }
    },
    methods: {
        imageLoaded() {
            objectFitImages('.img--bg');
            $('.img--bg').addClass('loaded');
            
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        if(this.rocket == null) {
            this.rocket = this.$store.state.rockets.filter((i) => { 
                return i.rocket_id === this.id  
            })[0];
        }
        this.numOfLaunches = this.$store.state.launches.filter((i) => { 
            return i.rocket.rocket_id === this.id
        }).length;
        this.rocketReady = true;
        window.addEventListener('load', () => {
            window.$ = jQuery;
        });
        let windowHeight = window.innerHeight;
        if($('#app').innerHeight() > windowHeight) {
            $(window).scrollTo(0);
        }
    },
    
}
</script>

<style>

</style>
